<div class="c-card" style="max-width:100%;width:300px">
	<div class="c-card__header c-card__header--s1 u-no-pr">
		<div class="o-grid">
			<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v u-no-p">
				<item-status [status]="vm.chat.privateChatFriend.status"></item-status>
			</div>
			<div class="o-grid__cell o-grid__cell--slim">
				<p class="c-text">{{ vm.chat.privateChatFriend.firstname }} {{ vm.chat.privateChatFriend.lastname }}</p>
			</div>
			<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v">
				<button id="closeButton" class="c-button c-button--icon c-button--s7 u-no-pv" (click)="vm.close()">
					<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
					<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
				</button>
			</div>
		</div>
	</div>
    <div *ngIf="vm.chat && vm.chat.id && vm.user?.businessUserType === 'SERVICE_PROVIDER'" style="background-color: rgb(153, 153, 153);color:#fff;padding:10px;" class="u-no-pr">
		<div style="float:right;" class="o-grid__cell o-grid__cell--w-fixed">
            <input-switch-new [isDisabled]="vm.chat.disabled"
                      [toggleFn]="vm.toggleChatDisabled"
                      [label]="(vm.chat.disabled ? 'Condition_Summary.Chat_Disabled' : 'Condition_Summary.Chat_Enabled') | translate">
            </input-switch-new>
        </div>
    </div>
	<item-messenger class="o-grid o-grid--column" [chat]="vm.chat" [isPopup]="true" [(isInfoHidden)]="vm.isInfoHidden" style="height:340px;position:relative;"></item-messenger>
</div>
